export const INIT_BTAX_DATA = "INIT_BTAX_DATA";
export const INIT_LOGGED_IN = "INIT_LOGGED_IN";

export const SET_LOADER_ON = "SET_LOADER_ON";
export const SET_LOADER_OFF = "SET_LOADER_OFF";
